import { Injectable, OnDestroy } from '@angular/core';
import { IvCertGenericResponseCertificateClientResponse } from '../../api/model/ivCertGenericResponseCertificateClientResponse';
import { CertService, CertificateClientResponse } from '../../api';
import { Subject } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { takeUntil } from 'rxjs/operators';

@Injectable()
export class CertificateService implements OnDestroy {
  private _certData: CertificateClientResponse = null;

  get certData(): CertificateClientResponse {
    return this._certData;
  }
  set certData(data: CertificateClientResponse) {
    this._certData = data;
  }

  callbackId: string = '';

  destroy$: Subject<boolean> = new Subject<boolean>();


  constructor(private _cert: CertService) { }

  async certGate(): Promise<string> {
    this.callbackId = uuidv4();
    const url = process.env.URL_CERTGATE;
    const uid = process.env.INTEGRATOR_KEY_CERTGATE;
    const urlCallback = window.location.href;

    try {
      await fetch(`${url}?uid=${uid}&callbackid=${this.callbackId}&callbackurl=${urlCallback}`);
    } catch (e) {
      console.log(e);
    }

    return this.callbackId;
  }

  getCertificate(callback: Function, operationId?: string): void {
    if (!operationId) {
      this.default(callback);
    } else {
      this.qualified(callback, operationId);
    }
  }

  private default(callback: Function): void {
    const data = { error: null, data: null };

    this._cert.certGetCertificateClient(this.callbackId, '1').pipe(takeUntil(this.destroy$)).subscribe(
      (response: IvCertGenericResponseCertificateClientResponse) => {
        this.certData = response.data;
        data.data = this.certData;
        callback(data);
      },
      (error: any) => {
        data.error = error;
        callback(data);
      }
    );
  }

  private qualified(callback: Function, operationId: string): void {
    const data = { error: null, data: null };

    this._cert.certGetCertificateClientQERDS(operationId, this.callbackId, '1').pipe(takeUntil(this.destroy$)).subscribe(
      (response: IvCertGenericResponseCertificateClientResponse) => {
        this.certData = response.data;
        data.data = this.certData;
        callback(data);
      },
      (error: any) => {
        data.error = error;
        callback(data);
      }
    );
  }

  checkCertificate(document: string): boolean {
    let dniNif = this.certData.parseCertInfo.certinfo.user.doc;
    if (this.certData.parseCertInfo.certinfo?.type == 'PRPJ' || this.certData.parseCertInfo.certinfo?.type == 'PR' || this.certData.parseCertInfo.certinfo?.type == 'PJ' || this.certData.parseCertInfo.certinfo?.type == 'PRAP') {
      if (this.certData.parseCertInfo.certinfo.org) {
        dniNif = this.certData.parseCertInfo.certinfo?.org.doc
      } else if (this.certData.parseCertInfo.certinfo?.user) {
        dniNif = this.certData.parseCertInfo.certinfo?.user.doc
      }
    } else {
      if (this.certData.parseCertInfo.certinfo?.user) {
        dniNif = this.certData.parseCertInfo.certinfo?.user.doc
      }
    }
    return document === (dniNif ? dniNif.toUpperCase() : null);
  }

  ngOnDestroy(): void {
    this.destroy$.unsubscribe();
  }

}
